import { render, staticRenderFns } from "./AvailabilityLeaves.vue?vue&type=template&id=06ca2530"
import script from "./AvailabilityLeaves.vue?vue&type=script&lang=js"
export * from "./AvailabilityLeaves.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityLeaves.vue?vue&type=style&index=0&id=06ca2530&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports